var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CF13D49C-E61A-46F8-8DE2-342C2C206656") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.0-Help-Center",
    transform: "translate(-1238.000000, -809.000000)",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1245.3325,822.634218 C1245.1264,822.865855 1244.82173,823 1244.49999,823 C1244.17825,823 1243.87357,822.865855 1243.66748,822.633964 L1238.251,816.524873 C1237.86806,816.0924 1237.93035,815.449927 1238.38966,815.09 C1238.85088,814.730073 1239.53227,814.788618 1239.9163,815.220327 L1243.41669,819.169091 L1243.41669,810.018182 C1243.41669,809.455382 1243.9012,809 1244.49999,809 C1245.09878,809 1245.58328,809.455382 1245.58328,810.018182 L1245.58328,819.169091 L1249.08395,815.220582 C1249.4669,814.789127 1250.14937,814.730327 1250.61058,815.090255 C1251.06963,815.450182 1251.13192,816.0924 1250.74897,816.525127 L1245.3325,822.634218 Z",
    id: "Sort-Alphabet-Ascending-path-Copy-10"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowDown.3338a59c2c805f9b67871eb2d0604254.svg";